import { render, staticRenderFns } from "./MobileDetail.vue?vue&type=template&id=4bb6913f&scoped=true"
import script from "./MobileDetail.vue?vue&type=script&lang=js"
export * from "./MobileDetail.vue?vue&type=script&lang=js"
import style0 from "./MobileDetail.vue?vue&type=style&index=0&id=4bb6913f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb6913f",
  null
  
)

export default component.exports